import { createSelector } from '@reduxjs/toolkit';

import { selectAdditionalInfoData, selectEmployerType, selectMobilePhone, selectWorkPhone } from 'entities/creditForm';

// в форму добавляем номер телефона, чтобы он был доступен при валидации
export const formDataSelector = createSelector(
  [selectAdditionalInfoData, selectMobilePhone, selectWorkPhone, selectEmployerType],
  (additionalData, mobilePhone, workPhone, employerType) => {
    return {
      ...additionalData,
      mobilePhone,
      workPhone,
      employerType,
    };
  },
);
